import React from 'react';
import { TextField, Input, Box }  from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { DatePicker, LocalizationProvider  } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import FormHelperText from '@material-ui/core/FormHelperText';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
	fullWitdth:{
		width: '100%'
	},
	root: {
		display: 'block',
	},
	asterick: {
		color: theme.palette.error.main,
	},
});

const getYearFromDashFormattedDateString = (value) => {
	if(value){
		return value.substr(0, value.indexOf("-"));
	}
	
	return value;
}

const getMonthFromDashFormattedDateString = (value) => {
	if(value){
		const startIndex = value.indexOf("-") + 1;
		const charsToTake =  value.lastIndexOf("-") - value.indexOf("-") - 1;
		let month = value.substr(startIndex, charsToTake);
		if(month.lenght < 1){
			month = `0${month}`;
		}

		return month;
	}
	
	return value;
}

const getDayFromDashFormattedDateString = (value) => {
	if(value){
		const startIndex = value.lastIndexOf("-") + 1;
		const charsToTake =  value.length - value.lastIndexOf("-") - 1;
		let day = value.substr(startIndex, charsToTake);
		if(day.length < 1){
			day = `0${day}`;
		}

		return day;
	}
	
	return value;
}

const setDatePickerDate = (value) => {
	if(value) {
		const year = getYearFromDashFormattedDateString(value);
		const month = getMonthFromDashFormattedDateString(value);
		const day = getDayFromDashFormattedDateString(value);
		
		// months are 0 based
		const inDate = new Date(year, month - 1, day);
		inDate.setFullYear(year);

		return inDate;
	}

	return null;
}

const ReduxFormDatePicker= ({
		classes,
		description,
		input: { onBlur, onFocus, value, ...input },
		labelShrink,
		meta: { error, touched },
		placeholder,
		required,
		...custom
	}) => (
	<FormControl className={classes.root} error={touched && !!error}>
		{placeholder && (
			<InputLabel htmlFor={input.name} shrink={labelShrink}>
				{placeholder}
				{required && !!error ? <span className={classes.asterick}> *</span> : null}
			</InputLabel>
		)}
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DatePicker							
				{...custom} 	
				value={setDatePickerDate(value)}
				onChange={(newValue) => {
					if(newValue){
						var newDateLocal = newValue.toLocaleDateString("us").replaceAll("/", "-");
						var monthAndDay = newDateLocal.substr(0, newDateLocal.lastIndexOf("-"));
						var year = newDateLocal.substr(newDateLocal.lastIndexOf("-") + 1, newDateLocal.lenght);
						var newDate = year + "-" + monthAndDay;
						onFocus(newDate); 
						onBlur(newDate);
					}
				}}
				inputFormat="MM/dd/yyyy"
				renderInput={(props) => <TextField 
					className={classes.fullWitdth}
					id={input.name}
					value={setDatePickerDate(value)}
					{...props}					
					/>}
			/>	
		</LocalizationProvider>
		{(touched && !!error && <FormHelperText>{error}</FormHelperText>) ||
			(description && <FormHelperText>{description}</FormHelperText>)}
	</FormControl>	
);

ReduxFormDatePicker.propTypes = {
	input: PropTypes.shape({
		name: PropTypes.string.isRequired,
		onFocus: PropTypes.func.isRequired,
		onBlur: PropTypes.func.isRequired,
		value: PropTypes.string.isRequired,
	}),
	description: PropTypes.string,
	meta: PropTypes.shape({ touched: PropTypes.bool, error: PropTypes.string }),
	placeholder: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
	}).isRequired,
	required: PropTypes.bool,
	labelShrink: PropTypes.bool,
};

ReduxFormDatePicker.defaultProps = {
	input: {},
	description: null,
	meta: {},
	placeholder: null,
	required: false,
	labelShrink: undefined,
};

export default withStyles(styles, { name: 'ReduxFormInput' })(ReduxFormDatePicker);
